<template>
	<el-dialog class="feedbackDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				上传高清图
			</div>
		</div>
		<div class="dislogConent">
			<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
				<el-form-item label="" prop="imgList">
					<div class="imgList">
						<div class="imgItem" v-for="(item,index) in ruleForm.imgList" :key="index">
							<img class="imgItemImg" :src="item" />
							<img class="delete" @click="ruleForm.imgList.splice(index, 1)"
								src="../assets/Feedback/delete.png" />
						</div>
						<div class="addImgBox" @click="uploadPhoto">
							<img class="addImg" src="../assets/Feedback/addImg.png" />
							上传图片
						</div>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer">
			<div class="menuBox">
				<el-button class="submit" type="primary" size="medium" @click="submitForm('ruleForm')">提交</el-button>
			</div>
		</div>
		<el-upload ref="upload" style="font-size: 0;" name="image" action="https://ht.daiyuart.com/api.php/set/Other/upload_img"
			:show-file-list="false" :limit="6" multiple :on-success="handlePhotoSuccess">
		</el-upload>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			orderId: {
				type: [String, Number],
				default: ''
			},
		},
		data() {
			return {
				ruleForm: {
					imgList: [],
				},
				rules: {
					imgList: [{
						required: true,
						message: '请至少上传一张图片',
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response) {
				this.ruleForm.imgList.push(response.data)
			},
			handleClose() {
				this.ruleForm.imgList = []
				this.$emit('close')
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Hua/dz_order_img', {
							id: this.orderId,
							img: this.ruleForm.imgList.join(','),
						}).then(res => {
							if (res.code == 1) {
								this.$emit('uploadSuc')
								this.handleClose()
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.feedbackDialog {
		::v-deep .el-dialog {
			width: 7.40rem;
			border-radius: .12rem;

			&__headerbtn {
				top: .24rem;
				right: .24rem;
			}

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							line-height: unset;

							.contentBox {
								width: 6.92rem;
								height: 3.25rem;
								background: #FFFFFF;
								border-radius: .04rem;
								border: .01rem solid #EFD8B8;
								padding: .12rem .12rem;
								position: relative;

								textarea {
									width: 100%;
									height: 100%;
									font-size: .14rem;
									padding: 0 0;
									border: none;
								}

								.textNum {
									position: absolute;
									right: .12rem;
									bottom: .12rem;
									display: flex;
									align-items: center;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;

									span {
										background: #FFFFFF;
										line-height: .2rem;
										color: #999999;
									}
								}
							}

							.imgList {
								display: flex;
								flex-wrap: wrap;

								.imgItem:nth-child(4n) {
									margin-right: 0;
								}

								.imgItem {
									margin-bottom: .16rem;
									margin-right: .16rem;
									display: flex;
									width: 1.6rem;
									height: 1.6rem;
									border-radius: .04rem;
									overflow: hidden;
									position: relative;

									.delete {
										position: absolute;
										top: .05rem;
										right: .05rem;
										width: .14rem;
										height: .14rem;
										cursor: pointer;
									}

									.imgItemImg {
										width: 1.6rem;
										height: 1.6rem;
										object-fit: cover;
									}
								}

								.addImgBox {
									width: 1.6rem;
									height: 1.6rem;
									border-radius: .04rem;
									background: #FFFFFF;
									border: 1px solid #EFD8B8;
									display: flex;
									flex-direction: column;
									align-items: center;
									justify-content: center;
									font-weight: 400;
									font-size: .12rem;
									color: #999999;
									cursor: pointer;

									.addImg {
										margin-bottom: .08rem;
										width: .27rem;
										height: .23rem;
									}
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: 0 .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>